import React = require('react');

interface ISectionNameProps {
  imageName: string;
  title: string;
}

export const SectionName = ({ imageName, title }: ISectionNameProps) => {
  return (
    <div style={{ margin: '0 0 20px 0', paddingTop: '20px' }}>
      <img height={'20px'} src={require(`../../../../img/${imageName}`)} alt={'Admiral'}
           style={{ marginRight: '10px' }}/>{title}
    </div>
  )
}
